/**
 * Fetch current prices for a list of variant GIDs using @inContext(country)
 * so prices reflect the buyer's market.
 */
const getVariantPrices = (variantIds, country) => `
  ${country ? `query @inContext(country: ${country})` : 'query'} {
    nodes(ids: [${variantIds.map((id) => `"${id}"`).join(', ')}]) {
      ... on ProductVariant {
        id
        price { amount currencyCode }
      }
    }
  }
`;

export default getVariantPrices;
